




import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Stat extends Vue {
  @Prop({})
  private value!: number;
  @Prop({ default: 80 })
  private failThreshold!: number;
  @Prop({ default: 20 })
  private passThreshold!: number;

  @Prop({ type: Boolean })
  private skipColor!: boolean;

  @Prop({ default: '' })
  private marker?: string;

  getClasses() {
    const count = this.value;
    if (this.skipColor) return {};
    return {
      fail: count >= this.failThreshold,
      pass: count < this.passThreshold,
    };
  }
}
